// plyrmatchportal.online is its own Hosting site running the same app (see
// scripts/build-plyrmatch-site.js), but only the PLYRMATCH Portal is reachable
// on it — any other path is sent to the same path on the IAP domain. Nothing
// here runs on any other hostname, so the IAP domain and localhost behave as if
// this file didn't exist.
export const PLYRMATCH_PORTAL_DOMAIN = 'plyrmatchportal.online';
export const IAP_PORTAL_ORIGIN = 'https://internationalacademyportal.com';
// PLYRMATCH's own tenant, for what only they have (Mentorship). Same id as
// functions/index.js.
export const PLYRMATCH_AGENCY_ID = 'pXABtENkyknCYJAKZ56b';

// Everything a PLYRMATCH player needs: signing in, accepting an invite, the
// portal itself, and a CV they've shared.
const PLYRMATCH_DOMAIN_PATHS = ['/login', '/reset-password', '/invite', '/plyrmatch', '/cv'];

// The site's Firebase default addresses count too, or they'd be an unrestricted
// way into the same app.
const PLYRMATCH_HOSTNAMES = [
  PLYRMATCH_PORTAL_DOMAIN,
  `www.${PLYRMATCH_PORTAL_DOMAIN}`,
  'plyrmatchportal.web.app',
  'plyrmatchportal.firebaseapp.com',
];

export function isPlyrmatchDomain(hostname = window.location.hostname) {
  return PLYRMATCH_HOSTNAMES.includes(hostname);
}

export function isAllowedOnPlyrmatchDomain(pathname) {
  return pathname === '/' || PLYRMATCH_DOMAIN_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Returns true if the page is on its way to the IAP domain, so the caller can
// skip rendering the path it's leaving.
export function leavePlyrmatchDomainIfNeeded({ pathname, search = '', hash = '' }) {
  if (!isPlyrmatchDomain() || isAllowedOnPlyrmatchDomain(pathname)) return false;
  window.location.replace(`${IAP_PORTAL_ORIGIN}${pathname}${search}${hash}`);
  return true;
}
